

import axios from "axios";

export async function getRecap(type,code) { 

     try {
         const response = await axios.get(`https://api.competition.cleges.com/api/v1/competitions/getRecap`)
         return response;
 
     }catch(error){
         return error?.response
     }
   } 

